import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { DocumentUpload } from './pages/DocumentUpload';
import { DocumentList } from './pages/DocumentList';
import { DocumentValidation } from './pages/DocumentValidation';
import { TestRunner } from './pages/TestRunner';
import { TestResults } from './pages/TestResults';
import { TestHistory } from './pages/TestHistory';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/upload" element={<DocumentUpload />} />
                    <Route path="/documents" element={<DocumentList />} />
                    <Route path="/documents/:id/validate" element={<DocumentValidation />} />
                    <Route path="/test" element={<TestRunner />} />
                    <Route path="/tests/:id" element={<TestResults />} />
                    <Route path="/history" element={<TestHistory />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                style: {
                  background: '#22c55e',
                },
              },
              error: {
                style: {
                  background: '#ef4444',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;